import { AQA_ELEMENTS_MARKER_LIST } from 'features/order-tracker/utils/aqaElementsIDList';
import { APPOINTMENT, DELIVERY } from '../../constants';

export const SERVICE_INFO = {
  [APPOINTMENT]: {
    title: 'Appointments',
    toDo: 'scheduled',
    done: 'completed',
    item: 'appointment',
    id: AQA_ELEMENTS_MARKER_LIST.summaryPage.orderSummary.yourDeliveriesAndAppointments.appointmentScheduled,
  },
  [DELIVERY]: {
    title: 'Deliveries',
    toDo: 'to be sent',
    done: 'sent',
    item: 'item',
    id: AQA_ELEMENTS_MARKER_LIST.summaryPage.orderSummary.yourDeliveriesAndAppointments.itemsSent,
  },
};
